import React from 'react';
import DocumentPreview from './DocumentPreview';
import { formatDate, formatFileSize } from '../utils/documentFormatters';

const DocumentCard = ({ document, onDelete, deleting, compact, t }) => (
  <article className="tw-overflow-hidden tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white">
    <a
      href={document.url}
      target="_blank"
      rel="noreferrer"
      className="tw-block tw-h-[96px] sm:tw-h-[110px] md:tw-h-[120px] tw-w-full tw-border-b tw-border-gray-200"
      title={document.filename}
    >
      <DocumentPreview document={document} />
    </a>

    <div className="tw-p-2">
      <a
        href={document.url}
        target="_blank"
        rel="noreferrer"
        className="tw-block tw-truncate tw-text-xs sm:tw-text-sm tw-font-medium tw-text-blue-600 hover:tw-underline"
        title={document.filename}
      >
        {document.filename}
      </a>
      <p className="tw-mt-0.5 tw-text-[11px] tw-text-gray-500">
        {formatFileSize(document.file_size)}
        {' - '}
        {formatDate(document.created_at)}
        {!compact && document.uploader_name ? ` - ${document.uploader_name}` : ''}
      </p>

      <div className="tw-mt-1 tw-flex tw-items-center tw-justify-end tw-gap-2">
        <a
          href={document.url}
          target="_blank"
          rel="noreferrer"
          className="tw-text-xs tw-font-medium tw-text-gray-600 hover:tw-underline"
        >
          {t('customerDocuments.open', { defaultValue: 'Abrir' })}
        </a>
        <button
          type="button"
          className="tw-text-xs tw-font-medium tw-text-red-500 hover:tw-underline disabled:tw-opacity-50"
          onClick={() => onDelete(document.id)}
          disabled={deleting}
        >
          {deleting
            ? t('customerDocuments.deleting', { defaultValue: 'Eliminando...' })
            : t('customerDocuments.delete', { defaultValue: 'Eliminar' })}
        </button>
      </div>
    </div>
  </article>
);

export default React.memo(DocumentCard);
